import React from 'react';

const PROJECTS = [
    {
        id: 1,
        title: 'SGEP-UKB',
        description: 'Système de gestion d\'établissement privé pour la gestion des étudiants et la gestion financière',
        technologies: ['React Native', 'Spring Boot', 'Node.js', 'Docker'],
        image: '/Projects/banner.png',  // Depuis le dossier public
        link: 'https://vps-700193cd.vps.ovh.net/'
    },
    {
        id: 2,
        title: 'Direction Pêche Continentale',
        description: 'Site officiel avec gestion de contenu dynamique',
        technologies: ['React', 'WordPress', 'PHP'],
        image: '/Projects/dpc.jpg',  // Depuis le dossier public
        link: '#'
    },
    {
        id: 3,
        title: 'Sanaragro',
        description: 'Plateforme e-commerce pour entreprise agroalimentaire',
        technologies: ['React', 'Node.js', 'MongoDB'],
        image: '/Projects/sanaragro.jpg',  // Depuis le dossier public
        link: '#'
    }
];

export default function Projects() {
    return (
        <section className="projects" id="projects">
            <div className="container">
                <div className="section-header">
                    <h2>Projets Réalisés</h2>
                    <p>Des solutions qui ont transformé les entreprises</p>
                </div>

                <div className="projects-grid">
                    {PROJECTS.map(project => (
                        <div key={project.id} className="project-card">
                            <img src={project.image} alt={project.title} className="project-image" />
                            <div className="project-content">
                                <h3>{project.title}</h3>
                                <p>{project.description}</p>
                                <div className="project-tech">
                                    {project.technologies.map(tech => (
                                        <span key={tech} className="tech-tag">{tech}</span>
                                    ))}
                                </div>
                                <a href={project.link} className="project-link">Voir le projet →</a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}